// @ts-nocheck
/* eslint-disable react/jsx-no-duplicate-props */
import React, { forwardRef } from 'react'
// Components
import TextField from './TextField'
// Data
// Assets

// eslint-disable-next-line react/display-name
const PhoneInput = forwardRef(({ label, inputProps, ...fieldProps }, ref) => {
  return <TextField {...fieldProps} ref={ref} label={label} inputProps={inputProps} />
})

// Exports
// PhoneInput.defaultProps = defaultProps
// PhoneInput.propTypes = propTypes
export default PhoneInput
